<template>
<body class="qaBody">
    <header class="header width_total_100 animateContent qaAnimate1">
        <div class="w_container">
            <div class="commonTop">
                <OmpLink></OmpLink>
            </div>
            <div class="bannerPart">
                <div class="line">
                    <img src="https://escloud.digiwincloud.com/static/zh-TW/img/LINE.png" alt="line"/>
                    <p>掃描二維碼添加LINE</p>
                </div>
                <div style="padding-left: 110px;">
                    <div>一鍵快速產生報表</div>
                    <p>打造您的專屬酷炫頁面</p>
                </div>
                <FreeTryButton @getFreeTryVisible="getVisible"></FreeTryButton>
            </div>
        </div>
    </header>
    <div class="width_total_100 proBottomBg ">
        <div class="qa">
            <div class="tree">
                <div class="warp">
                    <div class="square"></div>
                    <div class="line"></div>
                    <div class="mun">01</div>
                    <div class="title">
                        Tip Biu BI需要安裝哪些程式？
                    </div>
                    <div class="answer">
                        需要安裝同步器，用來將WF週期性的報表同步到Tip Biu BI
                    </div>
                </div>
                <div class="warp">
                    <div class="square"></div>
                    <div class="line"></div>
                    <div class="mun">02</div>
                    <div class="title">
                        哪裡可以獲取同步器安裝程式?
                    </div>
                    <div class="answer">
                        小管家會主動與客戶連繫安裝
                    </div>
                </div>
                <div class="warp">
                    <div class="square"></div>
                    <div class="line"></div>
                    <div class="mun">03</div>
                    <div class="title">
                        Tip Biu BI支援哪些資料來源?
                    </div>
                    <div class="answer">
                        支援WorkFlow ERP週期性報表及EXCEL檔
                    </div>
                </div>
                <div class="warp">
                    <div class="square"></div>
                    <div class="line"></div>
                    <div class="mun">04</div>
                    <div class="title">
                        Tip Biu BI可以設置哪些類型的圖表？
                    </div>
                    <div class="answer">
                        折線、柱狀、餅圖、圖等
                    </div>
                </div>
                <div class="warp">
                    <div class="square"></div>
                    <div class="line"></div>
                    <div class="mun">05</div>
                    <div class="title">
                        圖表數據更新的頻率?
                    </div>
                    <div class="answer">
                        Tip Biu BI並不限定數據更新的次數，用戶可根據實際情況，透過同步器設定同步時間和頻率
                    </div>
                </div>
                <div class="warp">
                    <div class="square"></div>
                    <div class="line"></div>
                    <div class="mun">06</div>
                    <div class="title">
                        Tip Biu BI是否提供免費試用？
                    </div>
                    <div class="answer">
                        30天免費體驗
                    </div>
                </div>
                <div class="warp">
                    <div class="square"></div>
                    <div class="line"></div>
                    <div class="mun">07</div>
                    <div class="title">
                        Tip Biu BI適合哪種職務使用?
                    </div>
                    <div class="answer">
                        BOSS、企業的中高管、定期製作圖表的助理/MIS、不懂技術但日常需要數據分析的一般使用者
                    </div>
                </div>
                <div class="warp">
                    <div class="square"></div>
                    <div class="line"></div>
                    <div class="mun">08</div>
                    <div class="title">
                        Tip Biu BI有哪些呈現方式？
                    </div>
                    <div class="answer">
                        PC端或手動行動裝置均可
                    </div>
                </div>
                <div class="warp">
                    <div class="square"></div>
                    <div class="line"></div>
                    <div class="mun">09</div>
                    <div class="title">
                        為什麼我配置好的圖表,別的用戶查看這份圖表的時候會顯示“無權限查看”?
                    </div>
                    <div class="answer">
                        該使用者沒有使用權限，需請貴司的管理者協助發佈產生使用者權限，即可使用
                    </div>
                </div>
                <div class="warp">
                    <div class="square"></div>
                    <div class="line"></div>
                    <div class="mun">10</div>
                    <div class="title">
                        Tip Biu BI軟體運行要求？
                    </div>
                    <div class="answer">
                        運行環境	.NET Core Runtime/SDK 2.2及以上<br/><br/>
                        瀏覽器  	Google Chrome 50 版本以上
                    </div>
                </div>
            </div>
        </div>
        <div class="w_container">
            <Footer></Footer>
        </div>
    </div>

    <Control></Control>
    <FreeTry :visible.sync="freeTryVisible"></FreeTry>
</body>
</template>
<script>
import OmpLink from "@/components/common/OmpLink.vue"
import Control from "@/components/common/Control.vue"
import Footer from "@/components/common/Footer.vue"
import FreeTryButton from "@/components/common/FreeTryButton.vue"
import FreeTry from "@/components/common/FreeTry.vue"

  export default {
    components: {
        OmpLink, Control,Footer, FreeTryButton, FreeTry
    },
    name: 'Qa',
    data() {
      return {
        freeTryVisible: false
      }
    },
    mounted() {
        this.FAQTopAnimate() // 顶部动画
    },
    created () {
        this.$http.post('/backend/web/record', {
            pageName: 'Qa',
            contentName : ''
        })
        .then(function (response) {
            if(response.status == 200){
                console.log("success");
            }
        })
        .catch(function (error) {
            console.log(error);
        });
    },
    methods: {
        FAQTopAnimate() {
            var qaAnimate_show1=1;
            $(".qaBody").children(".animateContent").each(function() {
                if($(this).hasClass("qaAnimate1") &&  parseInt(qaAnimate_show1)){
                    qaAnimate_show1 = 0;
                    $(this).find(".bannerPart").delay(800).addClass('animated fadeInUp');
                }
            });
        },
        getVisible(visible) {
            this.freeTryVisible = visible
        }
    }
  }
</script>
<style scoped>
    .header{
        height: 960px;
        background: url(../assets/img/quesH.png) no-repeat center top;
    }
    .header .slog{
        font-size: 44px;
        color: white;
        font-weight: 100;
    }
    .qa{
        margin: -560px auto 0;
        padding: 90px 67px 120px;
        width: 890px;
        background: #fff;
    }
    .tree{
        height: 1060px;
        border-left: #bcc8cf 1px solid;
    }
    .tree .warp{
        position: relative;
        height: 106px;
        width: 100%;
        text-align: left;
    }
    .warp .square {
        position: absolute;
        top: 0px;
        left: -9px;
        z-index: 3;
        width: 17px;
        height: 17px;
        background: #0099E6;
        -moz-transform: rotate(45deg);
        -o-transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
        transform: rotate(45deg);
    }
    .warp .line{
        position: absolute;
        top: 8px;
        left: 0px;
        z-index: 2;
        width: 50px;
        height: 1px;
        background:#bcc8cf;
    }
    .warp .mun{
        position: absolute;
        top: -16px;
        left: 26px;
        color:#001926;
        font-size: 18px;
        font-weight: bold;
    }
    .warp .title{
        position: absolute;
        top: -16px;
        left: 65px;
        font-size: 24px;
        color: #003B59;
    }
    .warp .answer{
        position: absolute;
        top: 24px;
        left: 65px;
        font-size: 14px;
        color: #001926;
        text-align: left;
    }
    .bannerPart p {
        margin-bottom: 30px;
    }
    
    .qa{
        width: 1024px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Qa.vue